import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_REWARDS_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemRewardsDiscountMaybe = props => {
  const { lineItems, isCustomer, intl } = props;

  const rewardsLineItem = lineItems.find(
    item => item.code === LINE_ITEM_REWARDS_DISCOUNT && !item.reversal
  );

  if (!isCustomer || !rewardsLineItem) {
    return null;
  }

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.rewardsDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, rewardsLineItem.lineTotal)}</span>
    </div>
  );
};

LineItemRewardsDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemRewardsDiscountMaybe;
